import React from 'react';
import PropTypes from 'prop-types';
import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import CircleIcon from '@mui/icons-material/Circle';
import Skeleton from '@mui/material/Skeleton';
import { RestrictionsColorMapper } from '../../helpers';
import { SECONDARY_STACK_CLASS_NAME } from '../../theme/constants/stack';
import { DEFAULT_ICON_CLASS_NAME } from '../../theme/constants/icon';

const RestrictionItem = ({ detail, isMobile, isSkeleton = false }) => {
  const getWidth = () => {
    if (isSkeleton) return '95%';
    return detail.status !== 'CREATED' ? '65%' : '95%';
  };

  return (
    <Stack
      className={SECONDARY_STACK_CLASS_NAME}
      p={1}
      sx={{ borderRadius: '15px', minHeight: { xs: '40px', md: '50px' }, p: { xs: 0.5, md: 1 } }}
      alignContent="center"
      justifyContent="center"
    >
      <Stack direction="row" alignItems="center">
        <Box
          sx={{ width: '5%' }}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <CircleIcon
            className={DEFAULT_ICON_CLASS_NAME}
            sx={{
              height: isMobile ? 10 : 15,
              width: isMobile ? 10 : 15,

            }}
          />
        </Box>
        <Box
          sx={{
            width: getWidth(),
            paddingLeft: '3px',
          }}
          display="flex"
          alignItems="center"
        >
          {isSkeleton ? (
            <Skeleton
              variant="text"
              width="80%"
              height={isMobile ? 16 : 20}
            />
          ) : (
            <Typography variant={isMobile ? 'small_2' : 'medium_1'} color="gray.A700" fontWeight="500">
              {detail.restrictionLabel}
            </Typography>
          )}
        </Box>
        {!isSkeleton && detail.status !== 'CREATED' && (
          <Box
            sx={{ width: '30%' }}
            display="flex"
            alignItems="flex-end"
            justifyContent="flex-end"
          >
            <Chip
              size="small"
              color={RestrictionsColorMapper(detail.status)}
              label={detail.statusLabel}
            />
          </Box>
        )}
      </Stack>
    </Stack>
  );
};

RestrictionItem.propTypes = {
  detail: PropTypes.shape({
    id: PropTypes.string,
    restrictionLabel: PropTypes.string,
    description: PropTypes.string,
    status: PropTypes.string,
    statusLabel: PropTypes.string,
  }),
  isMobile: PropTypes.bool.isRequired,
  isSkeleton: PropTypes.bool,
};

RestrictionItem.defaultProps = {
  detail: {},
  isSkeleton: false,
};

export default RestrictionItem;
